import React from "react";
import { Check } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { translations } from "../i18n/translations";
import { images } from "../data/images";

export default function Exclusivity() {
  const { t } = useLanguage();
  const tx = translations.exclusivity;

  return (
    <section className="relative bg-[#EDE6D7] py-24 lg:py-36">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-6 overflow-hidden">
            <img
              src={images.realHouseNight}
              alt="NACUII facade at night"
              loading="lazy"
              className="w-full h-[520px] lg:h-[700px] object-cover"
            />
          </div>
          <div className="lg:col-span-6">
            <div className="flex items-center gap-4 mb-7">
              <div className="h-[1px] w-10 bg-[#9C8456]" />
              <span
                className="text-[#9C8456] text-[11px] tracking-[0.45em] uppercase"
                style={{ fontFamily: "'Jost', sans-serif" }}
              >
                {t(tx.eyebrow)}
              </span>
            </div>
            <h2
              className="text-[#2A2A28] text-[34px] sm:text-[44px] lg:text-[54px] leading-[1.1] mb-8"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300 }}
            >
              {t(tx.title1)}
              <br />
              <em className="italic">{t(tx.title2)}</em>
            </h2>
            <p
              className="text-[#3a3a36] text-[15px] lg:text-[17px] leading-[1.85] mb-10"
              style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
            >
              {t(tx.intro)}
            </p>

            <ul className="space-y-4">
              {tx.features.map((f, i) => (
                <li
                  key={i}
                  className="flex items-start gap-4 pb-4 border-b border-[#D4CBB8]/60 last:border-0"
                >
                  <Check
                    className="w-5 h-5 text-[#9C8456] flex-shrink-0 mt-1"
                    strokeWidth={1.4}
                  />
                  <span
                    className="text-[#2A2A28] text-[15px] lg:text-[16px] leading-[1.6]"
                    style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
                  >
                    {t(f)}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
